import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
const CollapseBase = ({ title, rightContent, children, defaultExpanded = true, className }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    return (_jsxs("div", { className: classNames("uxpcore_collapse__container", className), children: [_jsxs("div", { className: "uxpcore_collapse__header", onClick: () => setIsExpanded(!isExpanded), children: [_jsxs("div", { className: "uxpcore_collapse__header-left", children: [_jsx("div", { className: classNames('uxpcore_collapse__icon', {
                                    'uxpcore_collapse__icon--expanded': isExpanded
                                }), children: _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'chevron-down'] }) }), _jsx("span", { className: "uxpcore_collapse__title", children: title })] }), rightContent && (_jsx("div", { className: "uxpcore_collapse__header-right", children: rightContent }))] }), isExpanded && (_jsx("div", { className: "uxpcore_collapse__content", children: children }))] }));
};
/**
 * @export
 * A component that displays a collapsible panel with a title and optional content.
 *
 * @example
 * ```
 * <Collapse
 *   title="Details"
 *   children={<p>This is the collapsible content.</p>}
 * />
 * ```
 *
 * @example
 * ```
 * <Collapse
 *   title={<h3>Custom Title</h3>}
 *   rightContent={<button>Edit</button>}
 *   children={<div>Custom content here</div>}
 *   defaultExpanded={false}
 *   className="custom-collapse"
 * />
 * ```
 *
 * @category Layout
 */
export const Collapse = memo(CollapseBase);
